import 'isomorphic-fetch'; /* global fetch:false */
import React from 'react';
import classnames from 'classnames';
import ClientInfoFields from '../ClientInfoFields';
import {
  clientInfoToNestioFormat,
  clientInfoToFormspree,
} from '../../services/clients';
import './waitlist-form.scss';
import axios from 'axios';

export default class WaitlistForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // Track where the form data is in the process of being submitted.
      // Can be: not-started, in-progress, success, or error.
      submissionStatus: 'not-started',

      // Whether the user previously tried to submit the form. That submit
      // may never have started though, if their data was invalid, so this
      // flag is independent of submission status above.
      hasAttemptedSubmit: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    const clientInfoForm = this.refs['client-info-form'];

    this.setState({ hasAttemptedSubmit: true });
    if (!clientInfoForm.validate({ autoFocus: true })) {
      return;
    }

    let unformatted_data = clientInfoForm.getData();
    unformatted_data.url_params = this.props.utmParams;

    this.setState({ submissionStatus: 'in-progress' });

    const nestioClientData = clientInfoToNestioFormat(
      unformatted_data,
      'api',
      '300 Ashland Waitlist'
    );
    const formspreeClientData = clientInfoToFormspree(unformatted_data, 'api');

    // let formspree_data = {
    //   _full_name: unformatted_data.firstName + " " + unformatted_data.lastName,
    //   _email: unformatted_data.emailAddress,
    //   _phone: unformatted_data.phoneNumber,
    //   ...unformatted_data
    // }
    // console.log("formspree_data", formspree_data)
    // console.log('formspreeClientData', formspreeClientData);
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      body: JSON.stringify(formspreeClientData),
    };

    fetch('https://formspree.io/xqkngoqb', requestOptions)
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.log('error:  ', error);
      });

    // fetch('/contact-us', {
    //   method: 'post',
    //   headers: {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify(nestioClientData)
    // })
    // .then((response) => {
    //   console.log(response);
    //   if (response.ok) {
    //     this.setState({ submissionStatus: 'success' });
    //     this.props.toggleForm();

    //     /* eslint-disable no-undef */
    //     typeof window !== 'undefined' && Array.isArray(window.dataLayer) &&
    //       window.dataLayer.push({'event': 'contact-form-submitted-successfully'});
    //     /* eslint-enable no-undef */
    //   }

    //   else {
    //     this.setState({ submissionStatus: 'error' });
    //   }
    // });

    // console.log('JSON CLIENT DATA', nestioClientData);

    try {
      /// req goes here
      axios({
        method: 'POST',
        url: 'https://nestiolistings.com/api/v2/clients',
        headers: {
          Authorization: 'Basic ' + btoa('0c44cf1104174061ad121134a3415451:'),
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        data: JSON.stringify(nestioClientData),
        dataType: 'json',
      }).then((response) => {
        // console.log(response);
        if (response.status === 201 || 200) {
          this.setState({ submissionStatus: 'success' });
          this.props.onSuccessSubmit();
          this.props.toggleForm(true);

          /* eslint-disable no-undef */
          typeof window !== 'undefined' &&
            Array.isArray(window.dataLayer) &&
            window.dataLayer.push({
              event: 'contact-form-submitted-successfully',
            });
          /* eslint-enable no-undef */
        } else {
          this.setState({ submissionStatus: 'error' });
        }
      });
    } catch (e) {
      console.log('error', e);
    }

    // For facebook and remarketing tracking, we rely on a global (unlike the
    // explicit import with gaTag), so  we must check that the global is there
    // as we expect it to be (esp. so we don't try to do tracking server side).
    /* eslint-disable no-undef */
    typeof fbq !== 'undefined' && fbq('track', 'Lead');
    typeof window !== 'undefined' &&
      typeof window.google_trackConversion === 'function' &&
      window.google_trackConversion({
        google_conversion_id: 878503069,
        google_conversion_label: 'fCacCPjOpXAQncnzogM',
        google_remarketing_only: false,
      });
    /* eslint-enable no-undef */
  }

  render() {
    const isLoading = this.state.submissionStatus === 'in-progress';

    return (
      <div className={classnames('contact-us-form', this.props.className)}>
        {/* {this.state.submissionStatus === 'success' &&
          <p role="alert" className='success'>
            Thank you! A leasing associate will be in touch with you shortly.
          </p>
        } */}
        <div className="contact-us-form__intro-text">
          {/* <p className="h4">Thank you for your interest in 300&nbsp;Ashland.</p> */}
          {/* <p style={{ marginBottom: "20px" }}>
            Please complete the below form and we’ll contact you with more
            information to schedule a viewing.
          </p> */}
        </div>

        <form onSubmit={this.handleSubmit}>
          <ClientInfoFields
            validateOnBlur={this.state.hasAttemptedSubmit}
            submissionStatus={this.state.submissionStatus}
            resetOnSubmissionSuccess={true}
            ref="client-info-form"
            options={[
              { id: 2895, label: '$2895' },
              { id: 3000, label: '$3000' },
              { id: 3500, label: '$3500' },
              { id: 4000, label: '$4000' },
              { id: 4500, label: '$4500' },
              { id: 5000, label: '$5000' },
              { id: 5500, label: '$5500' },
              { id: 6000, label: '$6000' },
              { id: 6500, label: '$6500' },
              { id: 7000, label: '$7000+' },
            ]}
          />

          <p
            style={{
              fontSize: '12px',
              lineHeight: '14px',
              paddingBottom: '15px',
            }}
          >
            By selecting Submit, you agree that Two Trees and its affiliates may
            call/text you about your inquiry, which may involve use of automated
            means and prerecorded/artificial voices. You don't need to consent
            as a condition of buying any property, goods, or services.
            Message/data rates may apply.
          </p>

          <button
            role="button"
            tabIndex="0"
            className={classnames('button button--primary button--submit-btn', {
              'button--loading': isLoading,
            })}
          >
            {isLoading ? <span className="spinner"></span> : 'Submit'}
          </button>
        </form>

        {this.state.submissionStatus === 'error' && (
          <p role="alert" className="error">
            We're sorry, an error has occurred while processing your request.
            Please check for errors in your inputs or try back again later.
          </p>
        )}

        <div className="contact-us-form__legal-text">
          <small>
            By clicking the Submit button, you are indicating that you have read
            and agree to our{' '}
            <a onClick={this.props.openTerms} onKeyPress={this.props.openTerms}>
              Terms of Use | Privacy Policy
            </a>
            .
          </small>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/WaitlistForm/WaitlistForm.js